<div #parent class="-api-spec-container">
    <div class="hosted-api-docs">
        <div id="apimatic-widget" class="-apimatic-container"></div>
    </div>
</div>
